<div class="dlg-hdr">
  <div class="dlg-hdr__title">
    <div class="dlg-hdr__icon-wrap"><mat-icon>sync</mat-icon></div>
    <div>
      <span>Caja ya existente</span>
    </div>
  </div>
  <button mat-icon-button class="dlg-hdr__close" (click)="closeDialog()" aria-label="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dlg-body">
  <div class="delete-info delete-info--info">
    <mat-icon>info</mat-icon>
    <div class="delete-info__text">
      El concepto y la cantidad coincide con una caja ya registrada en Handly, ¿desea añadir los asientos contables a la caja existente?
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dlg-actions">
  <button mat-stroked-button (click)="closeDialog()">Cancelar</button>
  <button mat-flat-button class="dlg-btn-save" (click)="startImport()">
    <mat-icon>sync</mat-icon> Sí, añadir asientos
  </button>
</mat-dialog-actions>
